declare global {
    interface Window {
        env: any
    }
}

// change with your own variables
type EnvType = {
    REACT_APP_CLIENTAPPLICATIONINSTANCE: string
}

export const env: EnvType = {
    ...import.meta.env,
    ...window.env
}